export const warehouseData = [
    {
        WHCode: "NJ7",
        City: "Freehold",
        State: "New Jersey",
        Country: "United States",
    },
    {
        WHCode: "DE",
        City: "Meiningen",
        State: "Thuringen",
        Country: "Germany",
    },
    {
        WHCode: "PA1",
        City: "Allentown",
        State: "Pennsylvania",
        Country: "United States",
    },
    {
        WHCode: "CAN1",
        City: "Mississauga",
        State: "Ontario",
        Country: "Canada",
    },
    {
        WHCode: "CN3",
        City: "Qingdao",
        State: "Shandong",
        Country: "China",
    },
    {
        WHCode: "CN4",
        City: "Shenzhen",
        State: "Guangdong",
        Country: "China",
    },
    {
        WHCode: "CN5",
        City: "Ningbo",
        State: "Zhejiang",
        Country: "China",
    },
    {
        WHCode: "IND1",
        City: "Mumbai",
        State: "Maharashtra",
        Country: "India",
    },
    {
        WHCode: "UK5",
        City: "Harlow",
        State: "Essex",
        Country: "United Kingdom",
    },
    {
        WHCode: "NJ6",
        City: "Eatontown",
        State: "New Jersey",
        Country: "United States",
    },
    {
        WHCode: "FR3",
        City: "Oudalle",
        State: "",
        Country: "France",
    },
    {
        WHCode: "ISR1",
        City: "Airport City",
        State: "",
        Country: "Israel",
    },
    {
        WHCode: "LA14",
        City: "City Of Industry",
        State: "California",
        Country: "United States",
    },
    {
        WHCode: "LA16",
        City: "Gardena",
        State: "California",
        Country: "United States",
    },
    {
        WHCode: "NJ15",
        City: "Dayton",
        State: "New Jersey",
        Country: "United States",
    },
    {
        WHCode: "NL1",
        City: "Rotterdam",
        State: "",
        Country: "Netherlands",
    },
    {
        WHCode: "SI1",
        City: "Skofja Loka",
        State: "",
        Country: "Slovenia",
    },
    {
        WHCode: "TX2",
        City: "Attleboro",
        State: "Massachusetts",
        Country: "United States",
    },
];
